import { createReducer } from "./../../../redux/reducers/functions";

export const EXPENSE_REPORTS_IS_LOADING = "EXPENSE_REPORTS_IS_LOADING";
const SET_EXPENSE_REPORTS_LIST = "SET_EXPENSE_REPORTS_LIST";
const SET_EXPENSE_REPORTS_WEEKLY = "SET_EXPENSE_REPORTS_WEEKLY";
const SET_EXPENSE_REPORTS_USER_WEEKLY = "SET_EXPENSE_REPORTS_USER_WEEKLY";
const SET_EXPENSE_REJECT_TYPES = "SET_EXPENSE_REJECT_TYPES";

const initialState = {
  isLoading: false,
  list: null,
  weeklyList: null,
  userWeekly: null,
  rejectTypes: null
};

const expenseReportsList = {
  [SET_EXPENSE_REPORTS_LIST]: (state, action) => {
    const expenseReportsList = action.payload;

    return { ...state, list: expenseReportsList };
  }
};

const expenseReportsWeeklyList = {
  [SET_EXPENSE_REPORTS_WEEKLY]: (state, action) => {
    const expenseReportsWeekly = action.payload;

    return { ...state, weeklyList: expenseReportsWeekly };
  }
};

const expenseReportsUserWeekly = {
  [SET_EXPENSE_REPORTS_USER_WEEKLY]: (state, action) => {
    const expenseReportsUserWeekly = action.payload;

    return { ...state, userWeekly: [...expenseReportsUserWeekly] };
  }
};

const expenseRejectTypes = {
  [SET_EXPENSE_REJECT_TYPES]: (state, action) => {
    return { ...state, rejectTypes: action.payload };
  }
};
const isLoading = {
  [EXPENSE_REPORTS_IS_LOADING]: (state, action) => {
    return { ...state, isLoading: action.payload };
  }
};

const presenceReducer = createReducer(initialState, {
  ...expenseReportsList,
  ...expenseReportsWeeklyList,
  ...expenseReportsUserWeekly,
  ...isLoading,
  ...expenseRejectTypes
});

export default presenceReducer;



// WEBPACK FOOTER //
// src/modules/presence/reducers/expenseReports.js